import React from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';

const ContentType = () => {
  const categories = [
    'Монгол улсын хууль',
    'УИХ-ын тогтоол',
    'Засгын газрын тогтоол',
    'Сайдын тушаал',
    'Захирлын тушаал',
    'Журам',
    'Эрдэмтдийн зөвлөл',
    'Бодлого',
    'Эмхэтгэл',
    'Цахим сэтгүүл',
    'НЭМ-ийн ноцтой байдал',
    'Ёс зүй',
    'Хяналт шинжилгээ',
    'Үйл ажиллагаа',
    'Ажлын байрны зар',
    'Хүний нөөцийн ил тод байдал',
    'НЭМҮТ-ээс үзүүлж байгаа үйлчилгээ'
  ];
  const {
    register,
    formState: { errors }
  } = useFormContext();

  return (
    <Card className="mb-3">
      <Card.Header as="h6" className="bg-light">
        Контентын төрөл
      </Card.Header>
      <Card.Body>
        <Row className="gx-2 gy-3">
          <Col md="12">
            <Form.Group>
              <Form.Label>Төрөл сонгох</Form.Label>
              <Form.Select
                {...register(`contentType`)}
                isInvalid={!!errors.contentType}
              >
                <option value="">сонголт</option>
                {categories.map((category, i) => (
                  <option key={i} value={category}>
                    {category}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.contentType?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ContentType;
